/* ============================================================
   SLOPE FACES, Hilfsskript für die Content-Sections.
   ------------------------------------------------------------
   Einzige Aufgabe: Buttons mit [data-sf-scroll] springen zum
   Face Picker. Der Kauf passiert ausschließlich dort, deshalb
   führt kein CTA auf eine andere Seite.

   Delegierter Listener, damit auch Sections funktionieren, die
   der Theme-Editor nachträglich einfügt.
   ============================================================ */

(function () {
  'use strict';

  function target() {
    return document.querySelector('[data-slope-faces]');
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-sf-scroll]');
    if (!btn) return;

    ev.preventDefault();

    /* Wenn der Picker auf der Seite ist, nutzen wir seine eigene
       Scroll-Funktion. Sonst zur Produktseite, denn ohne Picker
       gibt es hier nichts zu kaufen. */
    if (window.SlopeFacesPicker && target()) {
      window.SlopeFacesPicker.scrollTo();
      return;
    }

    var node = target();
    if (node) {
      node.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var href = btn.getAttribute('data-sf-href');
    if (href) window.location.href = href;
  });
})();

/* ============================================================
   UGC-LEISTE
   ------------------------------------------------------------
   Horizontales Scrollen mit Pfeilen und Punkten. Clips starten
   erst, wenn sie im Bild sind, und pausieren wieder. Ohne das
   laufen alle gleichzeitig und kosten Akku und Bandbreite.
   ============================================================ */

(function () {
  'use strict';

  function initUgc(root) {
    var track = root.querySelector('[data-sf-ugc-track]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.children);
    var dots  = root.querySelector('[data-sf-ugc-dots]');

    function cardStep() {
      if (cards.length < 2) return track.clientWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    function activeIndex() {
      var step = cardStep() || 1;
      return Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / step)));
    }

    /* Punkte */
    if (dots) {
      dots.innerHTML = cards.map(function (_, i) {
        return '<button class="sf-ugc-dot" type="button" role="tab" data-i="' + i + '" aria-label="Clip ' + (i + 1) + '"></button>';
      }).join('');

      Array.prototype.forEach.call(dots.children, function (b) {
        b.addEventListener('click', function () {
          track.scrollTo({ left: Number(b.dataset.i) * cardStep(), behavior: 'smooth' });
        });
      });
    }

    function syncDots() {
      if (!dots) return;
      var a = activeIndex();
      Array.prototype.forEach.call(dots.children, function (b, i) {
        b.classList.toggle('is-on', i === a);
        b.setAttribute('aria-selected', i === a);
      });
    }

    /* Pfeile */
    Array.prototype.forEach.call(root.querySelectorAll('[data-sf-ugc-step]'), function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: Number(btn.dataset.sfUgcStep) * cardStep(), behavior: 'smooth' });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { syncDots(); ticking = false; });
    }, { passive: true });

    syncDots();

    /* Abspielen nur im Sichtbereich. Ein pausiertes Video lädt
       dank preload="none" auch keine Daten. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target.querySelector('video');
          if (!v) return;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});   // Autoplay darf scheitern
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.45 });

      cards.forEach(function (c) { io.observe(c); });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sf-ugc]'), initUgc);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme-Editor fügt Sections nachträglich ein. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-sf-ugc]');
    if (el) initUgc(el);
  });
})();

/* ============================================================
   KARUSSELL
   ------------------------------------------------------------
   Eine gemeinsame Mechanik für alle Leisten mit Pfeilen und
   Zähler: Testimonials, Warum-Karten und alles Weitere. Die
   Section liefert nur das Markup, die Schrittweite ergibt sich
   aus dem Abstand der ersten beiden Elemente.
   ============================================================ */

(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-sf-car-track]');
    var count = root.querySelector('[data-sf-car-count]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    function step() {
      return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
    }
    function index() {
      return Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / (step() || 1))));
    }
    function sync() {
      if (count) count.textContent = (index() + 1) + '/' + slides.length;
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-sf-car-step]'), function (btn) {
      btn.addEventListener('click', function () {
        /* Am Ende zurück an den Anfang, sonst wirkt der Pfeil defekt. */
        var next = index() + Number(btn.dataset.sfCarStep);
        if (next < 0) next = slides.length - 1;
        if (next > slides.length - 1) next = 0;
        track.scrollTo({ left: next * step(), behavior: 'smooth' });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    sync();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sf-car]'), initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-sf-car]');
    if (el) initCarousel(el);
  });
})();

/* ============================================================
   RESERVIERUNGS-COUNTDOWN IM WARENKORB
   ------------------------------------------------------------
   Markup und Dauer in snippets/sf-cart-reserve.liquid.
     - Ablaufzeit liegt in localStorage, nicht im Speicher. Ein
       Neuladen setzt den Timer deshalb nicht zurueck.
     - Ist das Fenster abgelaufen, verschwindet die Leiste still.
     - Leerer Warenkorb loescht die Ablaufzeit, der naechste
       Warenkorb bekommt also ein frisches Fenster.

   Es wird jede Sekunde neu im DOM gesucht, statt sich ein Element
   zu merken. Grund: Der Cart Drawer rendert seinen Inhalt nach
   jedem Add to Cart komplett neu und ersetzt das Element dabei.
   Eine gemerkte Referenz zeigt danach auf abgeraeumtes Markup.
   ============================================================ */
(function () {
  /* Sperre gegen doppeltes Laden. Zwei Intervalle wuerden dieselbe
     Uhr gegeneinander schreiben und flackern lassen. */
  if (window.sfReserveLaeuft) return;
  window.sfReserveLaeuft = true;

  var KEY = 'sf_cart_reserved_until';

  /* Rueckfall in den Arbeitsspeicher, falls localStorage nicht
     nutzbar ist.

     Ohne ihn stand der Timer fuer immer still: lesen() liefert dann
     bei jedem Tick 0, der Ablaufzeitpunkt wird jede Sekunde neu
     gesetzt und die Anzeige bleibt auf dem Startwert kleben.

     Betrifft keinen Randfall. Die Theme-Vorschau im Shopify-Admin
     laedt den Shop in einem iframe, dort ist der Speicher haeufig
     blockiert. Dazu privater Modus und blockierte Cookies.

     Im Rueckfall laeuft die Uhr normal weiter, sie ueberlebt dann
     nur kein Neuladen. Das ist der Preis, aber besser als eine
     eingefrorene Uhr. */
  var speicherNutzbar = true;
  var imArbeitsspeicher = 0;

  function lesen() {
    if (!speicherNutzbar) return imArbeitsspeicher;
    try {
      /* Erfolgreich gelesene Werte werden mitgefuehrt. Faellt der
         Speicher erst mitten in der Sitzung aus, laeuft die Uhr
         dadurch an der richtigen Stelle weiter, statt das Fenster
         neu zu starten. */
      imArbeitsspeicher = parseInt(localStorage.getItem(KEY), 10) || 0;
      return imArbeitsspeicher;
    } catch (e) {
      speicherNutzbar = false;
      return imArbeitsspeicher;
    }
  }

  function schreiben(wert) {
    imArbeitsspeicher = wert;
    if (!speicherNutzbar) return;
    try { localStorage.setItem(KEY, String(wert)); }
    catch (e) { speicherNutzbar = false; }
  }

  function loeschen() {
    imArbeitsspeicher = 0;
    if (!speicherNutzbar) return;
    try { localStorage.removeItem(KEY); } catch (e) { speicherNutzbar = false; }
  }

  function zweiStellen(n) { return n < 10 ? '0' + n : String(n); }

  /* Jede Ziffer bekommt eine eigene Box fester Breite, siehe
     .sf-reserve__d in sf-sections.css.

     Grund: Poppins hat keine Tabellenziffern. Gemessen bei 14px ist
     die 1 nur 5.26px breit, die 4 dagegen 9.48px. Ueber vier Ziffern
     summiert sich das auf bis zu 17px, und alles hinter der Uhr
     wandert im Sekundentakt mit. font-variant-numeric hilft nicht,
     die Schrift liefert die Tabellenziffern schlicht nicht mit.

     Der Doppelpunkt bleibt ohne Box, der ist ohnehin immer gleich.
     Der Text kommt aus Zahlen, enthaelt also nie fremdes Markup. */
  function uhrSetzen(uhr, text) {
    var html = '';
    for (var i = 0; i < text.length; i++) {
      var z = text.charAt(i);
      html += z === ':' ? ':' : '<span class="sf-reserve__d">' + z + '</span>';
    }
    if (uhr.innerHTML !== html) uhr.innerHTML = html;
  }

  function tick() {
    var el = document.querySelector('[data-sf-reserve]');

    /* Kein Element heisst leerer Warenkorb. Fenster zuruecksetzen,
       damit der naechste Warenkorb wieder volle Zeit hat. */
    if (!el) { loeschen(); return; }

    var sekunden = parseInt(el.getAttribute('data-sf-reserve-seconds'), 10);
    if (!sekunden || sekunden < 1) sekunden = 588;
    var fenster = sekunden * 1000;

    var ende = lesen();
    var jetzt = Date.now();

    /* Kein Fenster, oder ein unplausibel weit entferntes, etwa aus
       einer alten Einstellung. Neu setzen. */
    if (!ende || ende > jetzt + fenster) {
      ende = jetzt + fenster;
      schreiben(ende);
    }

    var rest = ende - jetzt;
    if (rest <= 0) { el.hidden = true; return; }

    var sekundenGesamt = Math.ceil(rest / 1000);
    var uhr = el.querySelector('[data-sf-reserve-clock]');
    if (uhr) {
      /* Minuten bewusst auch zweistellig, also 09:59 statt 9:59,
         damit beim Sprung von 10:00 kein Zeichen wegfaellt. */
      uhrSetzen(uhr, zweiStellen(Math.floor(sekundenGesamt / 60)) + ':' + zweiStellen(sekundenGesamt % 60));
    }
    el.hidden = false;
  }

  tick();
  setInterval(tick, 1000);

  /* Der Cart Drawer tauscht sein Markup nach jedem Add to Cart
     komplett aus. Das neue Markup bringt den Startwert aus Liquid
     mit, der fuer einen wiederkehrenden Besucher aber zu hoch ist.
     Ohne diesen Beobachter stuende dort bis zum naechsten Tick bis
     zu eine Sekunde lang die falsche Zeit und spraenge dann
     sichtbar auf den echten Wert.

     Der Callback laeuft als Microtask direkt nach der Aenderung und
     damit vor dem naechsten Zeichnen. Die Korrektur wird also nie
     sichtbar. */
  function beobachte() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;

    /* tick schreibt die Uhr innerhalb des beobachteten Bereichs.
       Ohne diese Sperre loeste der Beobachter sich selbst aus. */
    var laeuftGerade = false;
    new MutationObserver(function () {
      if (laeuftGerade) return;
      laeuftGerade = true;
      try { tick(); } finally { laeuftGerade = false; }
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beobachte);
  } else {
    beobachte();
  }
})();
